import { useCallback } from 'react';
import type { FloatingButton } from 'shared/src/api/promotionsService/getPromotionComponents/types';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useClickFloatingButton = (
  button: FloatingButton,
  buttonIdx: number,
) => {
  const goodsSno = useGoodsSno();

  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(() => {
    logGoodsAnalytics({
      name: 'CLICK_FLOATING_BUTTON',
      analytics: {
        ...button.logging.analytics,
        BUTTON_INDEX: buttonIdx,
        GOODS_SNO: goodsSno,
        SCREEN: 'GOODS_DETAIL',
      },
    });
  }, [button.logging.analytics, buttonIdx, goodsSno, logGoodsAnalytics]);
};
